import {
  DOWNLOAD_STATS_BEGIN,
  DOWNLOAD_STATS_SUCCESS,
  DOWNLOAD_STATS_FAILURE,
  DOWNLOAD_STATS_CLEAR,
} from './../../_types'
import analyticsAPI from '@api/analytics'
// https://date-fns.org/docs/format
import format from 'date-fns/format'

const getDefaultState = () => {
  return {
    downloadStatsCompleted: false,
    downloadStatsError: false,
    downloadStatsLoading: false,
  }
}

export const state = getDefaultState()

export const mutations = {
  [DOWNLOAD_STATS_BEGIN](state) {
    state.downloadStatsLoading = true
  },
  [DOWNLOAD_STATS_SUCCESS](state) {
    state.downloadStatsCompleted = true
    state.downloadStatsError = false
    state.downloadStatsLoading = false
  },
  [DOWNLOAD_STATS_FAILURE](state) {
    state.downloadStatsError = true
    state.downloadStatsLoading = false
  },
  [DOWNLOAD_STATS_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  downloadCampaignStats({ commit, dispatch, rootState }, { uuid, name }) {
    commit(DOWNLOAD_STATS_BEGIN)

    return analyticsAPI
      .downloadCampaignStats(uuid)
      .then((response) => {
        commit(DOWNLOAD_STATS_SUCCESS)
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute(
          'download',
          `onvocado_export_${name}-${format(new Date(), 'yyyy-MM-dd')}.csv`
        )
        document.body.appendChild(fileLink)

        fileLink.click()
      })
      .catch(() => commit(DOWNLOAD_STATS_FAILURE))
  },
  clearState({ commit }) {
    commit(DOWNLOAD_STATS_CLEAR)
  },
}
